
export const getPartnerInfo = () => {
    return fetch(`${process.env.REACT_APP_API_BASE}partner/info?id=${process.env.REACT_APP_PARTNER_ID}`, { 
        method: 'POST', 
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, 
        body: JSON.stringify({
            id: process.env.REACT_APP_PARTNER_ID,
        })})
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json()
        })
        .catch((error) => {
            throw error;
        });
}

export const getInformation = () => {
    return fetch(`${process.env.REACT_APP_API_BASE}partner/information?canvasser_id=${process.env.REACT_APP_CANVASSER_ID}`).then((response) => {
        if (!response.ok) {
            throw Error(response.statusText);
        }

        return response.json()
    }).catch((error) => {
        console.log(error);
    });
}